(function () {
    const container = document.querySelector('.auth-login');
    if (!container) {
        return;
    }

    const magicForm = container.querySelector('.js-login-magic');
    const passwordForm = container.querySelector('.js-login-password');
    if (!magicForm || !passwordForm) {
        return;
    }

    function show(mode) {
        const showMagic = mode === 'magic';
        magicForm.hidden = !showMagic;
        passwordForm.hidden = showMagic;

        const target = showMagic ? magicForm : passwordForm;
        const firstInput = target.querySelector('input[type="email"], input[type="password"]');
        if (firstInput) {
            firstInput.focus();
        }
    }

    const showPasswordBtn = container.querySelector('.js-show-password');
    if (showPasswordBtn) {
        showPasswordBtn.addEventListener('click', function () {
            show('password');
        });
    }

    const showMagicBtn = container.querySelector('.js-show-magic');
    if (showMagicBtn) {
        showMagicBtn.addEventListener('click', function () {
            show('magic');
        });
    }
})();
